'use strict';
angular.module('cgmemApp')
	.controller('FrontDeskSelectCtrl',
		function ($scope, $rootScope, $state, $http, $log, AppConfig, $uibModal) {

			var accts = [];
			var appConfig;

			$scope.searchTxt = '';
			$scope.matches = [];
			$scope.loaded = false;
			$scope.reservations = [];

			AppConfig.get()
				.then(d => {
					appConfig = d;
					this.appConfig = appConfig;	// very mixed style - migration to controllerAs syntax
				})
				.catch(err => $rootScope.$emit('generalAlert', "Error retrieving accounts: " + err.message))
				.finally(() => $scope.loaded = true);


			$scope.search = function () {
				if ($scope.searchTxt.length >= 2) {
					$http
						.get('/api/accounts', {
							params: {
								lastname: $scope.searchTxt,
								testaccounts: '0',
								activeonly: '1'
							}
						})
						.then(r => {
							$scope.matches = r.data;
							$scope.matches.forEach(a => {
								a.surnames = _(a.members).filter({ deleted: false }).map('lastName').uniq().toString();

								if (_(a.members).find(function (im) { return !im.deleted && im.lastName.toLowerCase() == $scope.searchTxt.toLowerCase() }))
									a.matchScore = 5;
								else if (a.surnames.toLowerCase().indexOf($scope.searchTxt.toLowerCase()) > -1)
									a.matchScore = 3;
								else
									a.matchScore = 1;
								if (a.sMS && appConfig.season in a.sMS)
									a.matchScore *= 2;
							});
						});
				}
			}

			_.forEach(accts, function (a) {
				a.surnames = _(a.members).filter({ deleted: false }).map('lastName').uniq().toString();
			})
			$scope.accounts = accts;

			$scope.select = function (a) {
				var selectedAccount = {
					_id: a._id,
					accountNumber: a.accountNumber,
					balance: a.balance,
					sMS: a.sMS && a.sMS[appConfig.season],
					members: _.filter(a.members, { deleted: false, nonMember: false }),
					checkinNote: a.checkinNote
				}
				selectedAccount.members.forEach(m => m.reservation = $scope.reservations.find(r => r._id === m._id));
				$state.go('^.checkin', { selectedAccount: selectedAccount })
			}

			$scope.reportProblem = function () {
				var modalInstance = $uibModal.open({
					templateUrl: 'reportProblem.html',
					controller: 'reportProblemCtrl',
				});

				modalInstance.result.then(function (t) {
					$scope.loading = true;
					$http.post('/api/checkins/problem', { problem: t })
						.then(function () {
							$scope.loading = false;
						}, function (err) {
							$scope.loading = false;
							$rootScope.$emit('generalAlert', 'Error reporting problem' + err.statusText + ": " + err.data);
						});
				}, function () {
					// cancelled
				});
			}
/*
			const getReservations = function () {
				$http.get('/reservations', { params: { now: "1", allaccounts: "1" } })
					.then(r => $scope.reservations = r.data.map(r => r.members).flat())
					.catch(err => $rootScope.$emit('generalAlert', 'Problem getting reservations:', err.data || err.statusText));
			}
			getReservations();

			$scope.$on('socket:reservation', (ev, d) => {
				getReservations();
			})
			$scope.$on('socket:slotStart', (ev, d) => {
				getReservations();
			})
			$scope.$on('socket:slotEnd', (ev, d) => {
				getReservations();
			})

			$scope.viewRservations = function () {
				var modalInstance = $uibModal.open({
					templateUrl: 'viewReservations.html',
					resolve: {
						reservations: () => $scope.reservations
					},
					controller: ($scope, reservations) => $scope.reservations = reservations
				});

				modalInstance.result.then(() => null).catch(err => null);
			}
*/

		})
	.controller('FrontDeskCheckInCtrl', function ($rootScope, $scope, $http, $log, $state, $stateParams, $uibModal, CheckIn) {
		$scope.selectedAccount = $stateParams.selectedAccount;
		$scope.guests = 0;

		$scope.qtySelected = function () {
			if ($scope.selectedAccount && $scope.selectedAccount.members)
				return _.filter($scope.selectedAccount.members, { checkIn: true }).length;
			return 0;
		}

		$scope.checkIn = function () {
			CheckIn.checkIn(
				$scope.selectedAccount.members
					.filter(m => m.checkIn)
					.map(m => ({ _id: m._id, guestOf: null, method: 'Staff' }))
			);

			if ($scope.guests)
				$state.go("^.guests", {
					accountId: $stateParams.selectedAccount._id,
					hostMemberId: ($scope.selectedAccount.members.find(m => m.checkIn))._id,
					guestQty: $scope.guests
				});
			else
				$state.go("^.search");
		}

		$scope.assignTag = function (m) {
			var modalInstance = $uibModal.open({
				templateUrl: 'assignTag.html',
				controller: 'assignTagCtrl',
				resolve: {
					m: function () {
						m.accessId = '';
						return m;
					}
				}
			});

			modalInstance.result.then(function (tagId) {
				$log.log("tag is", tagId);
				$scope.loading = true;
				$http.put('/api/accounts/' + $scope.selectedAccount._id + '/members/' + m._id + '/accessid', { accessId: tagId })
					.then(function () {
						m.accessId = tagId;
						$scope.loading = false;
					}, function (err) {
						$scope.loading = false;
						$rootScope.$emit('generalAlert', 'Error saving tag: ' + err.statusText + ": " + err.data);
						m.accessId = '';
					});
			}, function () {
				// cancelled
			});
		}

		$scope.infoTag = function (m) {
			var modalInstance = $uibModal.open({
				templateUrl: 'infoTag.html',
				controller: 'infoTagCtrl',
				resolve: {
					m: function () {
						return m;
					}
				}
			});

			modalInstance.result.then(function () {
				$scope.loading = true;
				$http.put('/api/accounts/' + $scope.selectedAccount._id + '/members/' + m._id + '/accessid', { accessId: "" })
					.then(function () {
						m.accessId = "";
						$scope.loading = false;
					})
					.catch(function (err) {
						$scope.loading = false;
						$rootScope.$emit('generalAlert', 'Error saving tag: ' + err.statusText + ": " + err.data);
					});
			}, function () {
				// cancelled
			});
		}
	})
	.controller('FrontDeskGuestsCtrl', function ($rootScope, $scope, $q, $state, $stateParams, $uibModal, AppConfig, Transaction, CheckIn, Pass) {
		$scope.loading = true;
		$scope.totalGuests = $stateParams.guestQty;

		$q.all([AppConfig.get(), Pass.get($stateParams.accountId, 'guestPass')])
			.then(function (r) {
				$scope.pass = r[0].products.find(e => e.passType === "guestPass" && e.passQty === 1);
				if (!$scope.pass)
					return $q.reject("No valid guest pass product defined - contact support");
				$scope.price = Transaction.currentPrice($scope.pass);
				if (!$scope.price)
					return $q.reject("Guest pass product does not have a current price - contact support");
				$scope.availablePasses = r[1].length;
				$scope.usePassQty = Math.min($scope.totalGuests, $scope.availablePasses);
				$scope.maxPassQty = $scope.usePassQty;
			})
			.catch(function (err) {
				$rootScope.$emit('generalAlert', err);
				$state.go('authenticated.frontdesk.frame.search');
			})
			.finally(function () {
				$scope.loading = false;
			});

		$scope.credit = () => {
			Transaction.initialize()
				.then(() => {
					var t = new Transaction.transaction($scope.pass, null, 'purchase',
						Transaction.currentPrice($scope.pass) * ($scope.totalGuests - $scope.usePassQty), null, null, $scope.totalGuests - $scope.usePassQty);
					t.accountId = $stateParams.accountId; t.account = {};
					Transaction.addTransactionToCart(t);

					return $uibModal.open({
						templateUrl: 'app/frontdesk/frontdesk-ccpay.html',
						controller: 'FrontDeskCCPayCtrl',
						controllerAs: 'ccpc',
						resolve: {
							accountId: () => $stateParams.accountId
						}
					}).result;
				})
				.then(() => doCheckIn())
				.then(() => $state.go('authenticated.frontdesk.frame.search'))
				.catch(err => {
					Transaction.emptyCart();	// remove transaction in case cancelled
					if (err)
						$rootScope.$emit('generalAlert', err);
				});
		}

		$scope.square = function () {
			$uibModal.open({
				templateUrl: 'confirmSquare.html',
				scope: $scope
			}).result
				.then(() => doCheckIn())
				.then(() => $state.go('authenticated.frontdesk.frame.search'))
				.catch(err => {
					if (err)
						$rootScope.$emit('generalAlert', err);
				});
		}

		$scope.done = () => {
			doCheckIn()
				.then(() => $state.go('authenticated.frontdesk.frame.search'))
				.catch(err => {
					if (err)
						$rootScope.$emit('generalAlert', err);
				});
		}

		function doCheckIn() {
			var checkIns = [];
			var ci = {
				_id: null,
				guestOf: $stateParams.hostMemberId,
				method: 'Staff'
			}

			for (var i = 0; i < $stateParams.guestQty; i++) {
				checkIns.push(ci);
			}

			let jobs = [ CheckIn.checkIn(checkIns) ];
			if($scope.usePassQty)
				jobs.push(Pass.use($stateParams.accountId, "guestPass", $scope.usePassQty));

			return $q.all(jobs);
		}
	})

	.controller('assignTagCtrl', function ($scope, $uibModalInstance, $log, m) {
		$scope.m = m;
		$scope.tagId = ''
		$scope.ok = function () {
			$uibModalInstance.close($scope.tagId);
		};
		$scope.$on('socket:fobFailure', (ev, d) => {
			$scope.tagId = d.accessId;
			$uibModalInstance.close($scope.tagId);
		});

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	})
	.controller('infoTagCtrl', function ($scope, $uibModalInstance, m) {
		$scope.m = m;
		$scope.ok = function () {
			$uibModalInstance.close();
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	})
	.controller('reportProblemCtrl', function ($scope, $uibModalInstance) {
		$scope.problemText = "";
		$scope.ok = function () {
			$uibModalInstance.close($scope.problemText);
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	})
	.controller('guestFeesCtrl', function ($scope, $uibModalInstance) {
		$scope.ok = function () {
			$uibModalInstance.close($scope.problemText);
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	});